import React from 'react'
import { Link } from 'react-router'
import styled from 'styled-components'

const SocialA = styled(Link)`
  color: grey;
  &:hover {
    opacity: .8;
  }
`

export default SocialA



// WEBPACK FOOTER //
// ../components/styled/SocialA.js